import { CUSTOMER_ADDRESS_UPDATED, CUSTOMER_ADDRESS_READY } from './actions';

export function customerAddressReducer(state = null, action) {
  switch (action.type) {
    case CUSTOMER_ADDRESS_UPDATED:
      return action.address;
    case CUSTOMER_ADDRESS_READY:
      return action.address;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/services/DataServices/CustomerAddressService/reducers.js